import React from "react";
import { wrap } from "./RydTestbedWrap";
import { RydSelectedNotesInfobox } from "../components/RydSelectedNotesInfobox";
import { NoteSelectionGroup } from "../utils/NoteSelectionGroup";
import { HorizontalNoteContainer } from "../model/containers";
import {
    Note,
    NoteDuration,
    NoteVelocity
} from "../model/core";


function createRandomNoteSelectionGroups(): Map<number, NoteSelectionGroup> {
    const groups = new Map<number, NoteSelectionGroup>();
    const numGroups = Math.floor(Math.random() * 3) + 1; // random count between 1 and 3
    for (let i = 0; i < numGroups; i++) {
        groups.set(i, createRandomNoteSelectionGroup());
    }
    return groups;
}

function createRandomNoteSelectionGroup(): NoteSelectionGroup {
    const hnc = new HorizontalNoteContainer({ length: 128 });
    const group = new NoteSelectionGroup(hnc, { start: 0, top: 0, left: 0, width: 128, height: 10 });
    const numNotes = Math.floor(Math.random() * 8) + 5; // random count between 5 and 12
    const durations: NoteDuration[] = [1, 2, 4, 8].map(n => new NoteDuration(n)); // example note durations

    for (let i = 0; i < numNotes; i++) {
        const start = Math.floor(Math.random() * 100); // arbitrary random start value
        const noteIndex = Math.floor(Math.random() * 80); // arbitrary note index (0 - 79)
        const note = Note.fromIndex(noteIndex);
        const duration = durations[Math.floor(Math.random() * durations.length)];
        const velocity = (0 | Math.random() * 127) as NoteVelocity;
        group.addNote(start, note, duration, velocity);
    }
    return group;
}

function EurydiceSelectedNotesInfoboxTestbed() {
    return wrap(<>
        <h2>EurydiceSelectedNotesInfoboxTestbed testbed</h2>
        <RydSelectedNotesInfobox noteSelectionGroups={createRandomNoteSelectionGroups()} />
    </>);
}

export {
    EurydiceSelectedNotesInfoboxTestbed
};